export default __webpack_public_path__ + "static/bg_works-8169ca52de3dfcb4baea992270fb1d95.webp";